var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookActiveIc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 15.5h0c-.5-.9-.8-1.2-1.1-1.5-.3-.2-.6-.4-1-.5-.4-.1-.9-.1-1.8-.1h-1c-.8 0-1.2 0-1.5-.2-.3-.1-.5-.4-.6-.6-.2-.3-.2-.7-.2-1.5V4.9c0-.8 0-1.2.2-1.5.1-.3.4-.5.6-.6.3-.2.7-.2 1.5-.2h.3c1.6 0 2.4 0 3 .3.5.3 1 .7 1.3 1.3.3.6.3 1.4.3 3m0 8.3V7.1m0 8.4h0c.5-.9.8-1.2 1.1-1.5.3-.2.6-.4 1-.5.4-.1.9-.1 1.8-.1h1c.8 0 1.2 0 1.5-.2.3-.1.5-.4.6-.6.2-.3.2-.7.2-1.5V4.9c0-.8 0-1.2-.2-1.5-.1-.3-.4-.5-.6-.6-.3-.2-.7-.2-1.5-.2h-.3c-1.6 0-2.4 0-3 .3-.5.3-1 .7-1.3 1.3-.3.6-.3 1.4-.3 3",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.1
  })));
}
export default SvgBookActiveIc;